export default{textWeight:"Normal"};
